import React, { useState } from 'react';
import './MoodGames.css';

/**
 * PowerUp — "Power-Up Meter". Tap the battery to fill it with a little cheerful
 * energy; reach full and it celebrates with a gentle next-step suggestion. Purely
 * playful — no real charge, no pressure — and easy to leave.
 */
const STEPS = [
  { emoji: '💧', label: 'Sip some water' },
  { emoji: '🚶', label: 'Take a short walk' },
  { emoji: '🍎', label: 'Grab a small snack' },
  { emoji: '😮‍💨', label: 'Take a 5-minute break' },
];

export const PowerUp: React.FC = () => {
  const [pct, setPct] = useState(0);
  const done = pct >= 100;
  const tip = STEPS[Math.floor(Math.random() * STEPS.length)];
  const [shownTip] = useState(tip);

  const charge = () => setPct((p) => Math.min(100, p + 10));
  const reset = () => setPct(0);

  return (
    <div className="mm-game mm-game--power">
      <div className="mm-game__head">
        <h3 className="mm-game__title">Power-Up Meter</h3>
        <p className="mm-game__sub">Tap the battery to fill it with a little energy.</p>
      </div>

      {done ? (
        <div className="mm-game__done">
          <span className="mm-game__done-emoji">🔋</span>
          <span className="mm-game__done-title">Fully charged!</span>
          <span className="mm-game__done-sub">One small real-world top-up now: {shownTip.emoji} {shownTip.label}.</span>
          <button type="button" className="mm-game__btn mm-game__btn--ghost" onClick={reset}>Again</button>
        </div>
      ) : (
        <div className="mm-game__done" style={{ gap: 12 }}>
          <button
            type="button"
            className="mm-power__battery"
            aria-label={`Charge the battery, ${pct} percent`}
            onClick={charge}
          >
            <span className="mm-power__fill" style={{ width: `${pct}%` }} />
            <span className="mm-power__pct">{pct}%</span>
          </button>
          <span className="mm-power__bolts" aria-hidden="true">⚡⚡⚡</span>
          <span className="mm-game__sub">Keep tapping to reach 100%.</span>
        </div>
      )}
    </div>
  );
};

export default PowerUp;
